import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12" data-id="element-58">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-59">
        <div className="text-center md:text-left" data-id="element-60">
          <span className="text-xl font-bold text-white tracking-tight block mb-2" data-id="element-61">
            Viridia Analytics
          </span>
          <p className="text-sm" data-id="element-62">
            © 2026 Viridia Analytics. All rights reserved.
          </p>
        </div>

        <div className="flex gap-6 text-sm" data-id="element-63">
          <a href="#" className="hover:text-white transition-colors" data-id="element-64">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-65">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-66">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}